import React, { useState, useEffect } from 'react'
// import Card from '../../CustomComponents/Card';
import DynamicCard from '../../CustomComponents/DynamicHomeCard';
import DynamicCardSavings from "../../CustomComponents/DynamicCard";
import { width } from "../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../../CustomComponents/Loader';
import CustomTextInput from '../../CustomComponents/CustomtextInput';
import { UPDATE_CARDNAME, STATUS_SUCCESS_CODE, CAN_CREATE_SAVINGS_ACC, PAID_PROMO_KEY, GET_ACCOUNTS_FOR_TRANSFER, TINK_LINK_ENABLED_CHECK, GENERATE_OTP_ADD_ACH_ACCOUNT } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import { createTinkUrl, displayErrorMessage, displaySuccessMessage, MoreServices } from '../../../utils';
import { appTheme, retrieveData } from '../../../helpers/utils/Utils';
import LineBreaks from '../../../utils';
import HomeLayout from '../../Layout/HomeLayout';
import HomeHeader from '../../CustomComponents/HomeHeader';
import checkIcon from '../../../assets/images/Error.png';
import error_img from '../../../assets/images/error_3x.png'
import check_img from '../../../assets/images/check_3x.png'
import beneficiarysaving from '../../../assets/images/beneficiarysaving.png';
import ClimbImg from '../../../assets/images/illo-climb.png';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import FooterContent from '../../CustomComponents/Footer';
import logFirebaseEvents from '../../LogFirebaseEvents';
import CardHeading from '../../CustomComponents/CardHeading';
import BenificiaryPlus from "../../../assets/kudzu-plus-images/Benificiary.png"
import CustomModalPlus from '../../../kudzu_plus/helpers/customModalPlus';
import Arrow from '../../../assets/kudzu-plus-images/arrow-image.png';
import Cookies from 'js-cookie';
import TinkLinkModal from '../../CustomComponents/TinkLinkModal';
import Modal from '../../CustomComponents/Modal';
import { LOGIN_SESSION_KEY } from '../../../Redux/reducers';
import Custom2FA from '../../CustomComponents/Custom2FA';
import TwoFactTypeSelctionModal from '../../CustomComponents/TwoFactTypeSelctionModal';




// import DynamicCard from '../../../../CustomComponents/DynamicCard';

const ManageAccounts = ({ transactionDatas, onViewAllClick, viewAll }) => {
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appConfigData = useSelector(state => state.appConfigData);
  const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
  const [isTinkFlowEnabled, setIsTinkFlowEnabled] = useState(false);
  const appThemeData = appTheme(kudzuPlusTrue);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(); // Hook to access translation functions
  const cards = useSelector(state => JSON.parse(state.userCards));
  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
  const accessTokenToApi = useSelector(state => state.accessToken);
  const [editClicked, setEditClicked] = useState(false);
  const [showCheckImage, setshowCheckImage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const loggedInResponses = useSelector(state => JSON.parse(state.loggedInResponse));
  console.log(loggedInResponses?.IsB2CMFAEnable);
  const MFAValues = useSelector(state => state.b2cEnabled);
      
 const [showModelManage, setShowModelManage] = useState(false);
  const selectedItem = cards?.[0]
  const [newName, setNewName] = useState((selectedItem != undefined && selectedItem != null) ? selectedItem.NickName : "");

  const [loading, setLoading] = useState(false)
  const [infoMessage, setinfoMessage] = useState('');
  const [responseCode, setResponseCode] = useState('');
  const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[var(--add-extr-acc-high-clr)] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none text-[var(--twoFact-clr)]";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const [savingsTheme, setSavingsTheme] = useState(false);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [isSubFooter, setIsSubFooter] = useState(false);
  const [carousel, setCarousel] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const [subFooter, setSubFooter] = useState('');
  const [accounts, setAccounts] = useState([
          // { "AccountType": "ACH", "AccountName": "Checking Account .. 0318", "AccountId": 564199, "ACHAccountInternalId": 10131, "StatusCode": "PDG" },
          // { "AccountType": "ACH", "AccountName": "Checking Account .. 0318", "AccountId": 564199, "ACHAccountInternalId": 10131, "StatusCode": "" },
          // { "AccountType": "ACH", "AccountName": "Checking Account .. 0318", "AccountId": 564199, "ACHAccountInternalId": 10131, "StatusCode": "PDG" }
      ])
    const [show2faSelection, setshow2faSelection] = useState(false);
    const [isTinkModal, setIsTinkModal] = useState(false);
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const [otpGenerationType, setOtpGenerationType] = useState(false);
const location = useLocation();

const footerMsgstyles = "font-hanken-grotesk modal-title lg:text-[14px] md:text-[13px] sm:text-[13px] text-[14px] font-normal cursor-pointer pointer-events-none";
const [showErrorImg, setshowErrorImg] = useState(false);
const [btn2Focus, setBtn2Focus] = useState(false);
const [btn1TextColor, setBtn1TextColor] = useState(false);
const smiOneTrue = useSelector((state) => state.smiOneAccountTrue);


    const closeOTPVerifyModal = () => {
      setIsOTPVerifyModalOpen(false);
  }
   const onClickAddExternalAcc = async (type) => {
  
          if (twoFactAuthenticationDone) {
              if (isTinkFlowEnabled) openHeadsUpModalManage()
              else {
                  if (location.pathname.includes('/AccountServices/ManageExternalAccounts')) navigate('/AccountServices/ManageExternalAccounts/AddExternalAccount')
                  else navigate('/Settings/ManageExternalAccounts/AddExternalAccount')
  
              }
  
          }
          else {
              if (selectedItem?.CardKey == undefined) {
                  return
              }
              const deviceId = await retrieveData('updatedDeviceId');
              const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
  
              var object = {
                  // "cardKey": selectedItem?.CardKey,
                  // "action": "mobile"
              }
              if (type !== undefined || type !== null) {
                  object.IsEmail = (type == 'Email') ? true : false
              }
              var url = GENERATE_OTP_ADD_ACH_ACCOUNT.replace('{CARDKEY}', selectedItem?.CardKey)
              setLoading(true)
              const response = await PostRequest(url, object, headers)
              setTimeout(() => {
                  setLoading(false)
              }, 500);
  
              let parsedResponse = JSON.parse(response);
              if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
                  // adding session key to redux
                  const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.sessionId }
                  dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
                  //adding userid to redux
                  const userIdPayload = { userId: parsedResponse.Response.userId }
                  dispatch({ type: 'USER_ID', payload: userIdPayload });
  
                  setTimeout(() => {
                      setIsOTPVerifyModalOpen(true)
                  }, 1000);
              } else {
                  var arrMessages = parsedResponse.Messages;
                  var message = arrMessages[0];
                  var displayText = message.DisplayText;
              }
          }
      }

    let YOUR_AUTHENTICATION_LINK = createTinkUrl(appConfigData.TINK_LINK_ACCOUNT_CHECK_URL, appConfigData.TINK_CLIENT_ID, appConfigData.TINK_REDIRECT_URI)

  useEffect(() => {
          getExternalAccounts()
          isTinkLinkFlowEnabled();
      }, []);

      async function getExternalAccounts() {
              // if (!global.isNetworkConnected) {
              //     // SimpleToast.show(translate("no_network"));
              //     return;
              // }
              if (selectedItem?.CardKey == null || selectedItem?.CardKey == undefined) {
                  return
              }
              setLoading(true);
              const url = GET_ACCOUNTS_FOR_TRANSFER.replace('{CARD_KEY}', selectedItem?.CardKey) + '?statusCode=&ach=true'
              const deviceId = await retrieveData('updatedDeviceId');
              const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      
      
              const response = await GetRequest(url, headers)
      
              setTimeout(() => {
                  setLoading(false)
              }, 500);
      
              const responseObj = JSON.parse(response);
              if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
                  setTimeout(() => {
                      var arrAccounts = []
                      if (responseObj.Response != null || responseObj.Response != undefined) {
                          if (responseObj.Response.Accounts != null || responseObj.Response.Accounts != undefined) {
                              for (var i = 0; i < responseObj?.Response?.Accounts?.length; i++) {
                                  if (responseObj.Response.Accounts[i].ACHAccountInternalId != 0) {
                                      arrAccounts.push(responseObj.Response.Accounts[i])
                                  }
                              }
                              setAccounts(arrAccounts)
                          }
                      }
                  }, 1000);
              } else {
      
              }
          }
          const onAcptBtnClickManage = async () => {
            setShowModel(false)
            if (btn1Text == t("home")) {
                navigate('/home')
            } else if (btn1Text === 'Ok') {
                closeCustomAlertModal()
            } else if (btn1Text === t('add_via_direct_deposit')) {
                navigate('/AccountServices/Spending/ManageDirectDeposit')
            } else if (btn1Text == t('back_to_ext_accounts')) {
                navigate('/Settings/ManageExternalAccounts')
            }
            else if (btn1Text == t('try_again1')) {
                closeCustomAlertModal()
                setIsTinkModal(true)
            }
            else if (btn1Text == 'Continue') {
                logFirebaseEvents("Manage_External_Account", "Continue_Clicked", "Continue_Clicked", "", "");
                closeCustomAlertModalManage()
                setIsTinkModal(true)
            }
        }
   const isTinkLinkFlowEnabled = async () => {
  
          const deviceId = await retrieveData('updatedDeviceId');
          const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
  
          let url = `${TINK_LINK_ENABLED_CHECK}?cardKey=${selectedItem?.CardKey}`
          setLoading(true)
          var response = await GetRequest(url, headers)
          setTimeout(() => {
              setLoading(false)
          }, 500);
          let parsedResponse = JSON.parse(response);
  
          if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
  
              setIsTinkFlowEnabled(parsedResponse.Response.enabled)
  
          } else {
              var arrMessages = parsedResponse.Messages;
              var message = arrMessages[0];
              var displayText = message.DisplayText;
  
              showAlertModal(true, t("oops_exclamation"), displayText, '', true, false, t('ok'), '', false, '', '', false, false)
  
          }
  
      }
  

  const currentpath = useLocation()
  const moreServicesArray = [
    { name: 'Configure Notifications', actionType: '', path: '/Settings/notificationConfigure' },
    // { name: 'Manage Beneficiaries', actionType: '', path: '/Settings/ManageExternalAccounts' }
  ];

  const updatedServices = [...moreServicesArray];

if (!smiOneTrue) {
  updatedServices.push({ name: 'Manage Beneficiaries', actionType: '', path: '/Settings/ManageExternalAccounts' });
}
  const subObjectsArray = cards?.map(card => {
    return {
      AccountTypeName: card.AccountTypeName,
      CardKey: card.CardKey,
      OpenDate: card.ApplicationDate
    };
  });
  if (savingsCardAvailable == false && cards !== null && cards[0]?.AllowSavings) {
    const staticObject = {
      AccountTypeName: t('menu_savings'),
      CardKey: '',
      OpenDate: 'empty'
    };
    // subObjectsArray?.push(staticObject);
    subObjectsArray?.splice(1, 0, staticObject);
  }


  const handleRevertClick = () => {
    setinfoMessage('');
    setEditClicked(false);
  };


  const canCreateSavingsAccount = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setIsLoading(true)

    let finalUrl = CAN_CREATE_SAVINGS_ACC(cards[0].CardKey)
    var response = await GetRequest(finalUrl, headers)
    var responseObj = JSON.parse(response)
    setIsLoading(false)
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      const canCreateNew = responseObj.Response.canCreateNew
      const eligibleDate = moment(responseObj.Response.eligibleDate).format('MM/DD/YYYY')
      if (canCreateNew) {
        enrollSavingsAccount()

      } else {
        showAlertModal(true, t("oh_no"), t('unable_to_open'), `${t('u_will_be_eligible')} ${eligibleDate}. `, true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false, true)
      }
    } else {
      setTimeout(() => {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        showAlertModal(true, t("oh_no"), displayText, '', true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false)

        // setError(displayText)
      }, 500);
    }
  }

  const subComponent = () => {
    return (
      <div className=' flex justify-start items-start'>
        <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
          () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
      </div>
    )
  }

  const enrollSavingsAccount = () => {
    const savingsNewPayload = { savingsNewClicked: true };
    dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
    if (kudzuPlusTrue) {
      showAlertModalPlus(true, "",
        promoKey == PAID_PROMO_KEY ? t("Get_1.25%_APY_on_an_optional_savings_account_with_trial") : t('Get_1.25%_APY_on_an_optional_savings_account'),
        "", true, true, t("enroll"), t("may_be_later"), true, require('../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
        '',
        true, '', false, false, true, true);
    }
    else {
      showAlertModal(true, '', t('set_aside_money_for_the_things_that_matter'), t('add_savings_account_subTitle'), true, true, t('enroll'), t('may_be_later'), true, beneficiarysaving, true, true);
    }
  }



  useEffect(() => {
  }, [cards, dispatch]);

  //niharika
  // useEffect(() => {
    // showAlertModalPlus(true, "",
    //    <p className='mb-6'><span className='text-[var(--modal-text-highlight)]'>Let’s get started</span> with creating a Kudzu+ savings account!</p>,
    //   "Set aside money for the things that matter in an interest-earning account.",
    //   false, false, t("enroll"), t("may_be_later"), false,
    //   require('../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
    //   '', true, '', false, false, false, true, <button type="button"
    //     className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[16px]
    // text-white cursor-pointer flex justify-end items-center w-full" >
    //   {t('next')} <img
    //     src={Arrow}
    //     className="md:w-[9px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[9px] h-[14px] ml-2"
    //     alt="Arrow" />
    // </button>
    // );
  // }, []);


  //niharika

  const closeCustomAlertModal = () => {
    setShowModel(false);
  }
  const closeCustomAlertModalManage = () =>{
    setShowModelManage(false);
  }

  const onAcptBtnClick = async () => {
    setShowModelManage(false)
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    } else if (btn1Text == t('home')) {
      navigate('/home')
    }
    else if (btn1Text == t('continue')){
      logFirebaseEvents("Manage_External_Account", "Continue_Clicked", "Continue_Clicked", "", "");
      closeCustomAlertModal()
      setIsTinkModal(true);
    }

  }
  const onCancelBtnClick = () => {
    if (btn2Text == t('back_to_ext_accounts')) {
        navigate('/Settings/ManageExternalAccounts')
    } else if (btn2Text == 'Cancel') {
        logFirebaseEvents("Manage_External_Account", "Cancel_Clicked", "Cancel_Clicked", "", "");
        closeCustomAlertModal()
    } else if (btn2Text == t("back_to_settings")) {
        navigate('/Settings')
    } else if (btn2Text == t("home")) {
        navigate('/home')
    }
    else {
        closeCustomAlertModal()
    }
}
const onCancelBtnClickManage = () => {
  if (btn2Text == t('back_to_ext_accounts')) {
      navigate('/Settings/ManageExternalAccounts')
  } else if (btn2Text == 'Cancel') {
      logFirebaseEvents("Manage_External_Account", "Cancel_Clicked", "Cancel_Clicked", "", "");
      closeCustomAlertModalManage()
  } else if (btn2Text == t("back_to_settings")) {
      navigate('/Settings')
  } else if (btn2Text == t("home")) {
      navigate('/home')
  }
  else {
    closeCustomAlertModalManage()
  }
}

  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage, subFooter) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)// gradient button for popup
    setLargeImage(largeImage)
    setSubFooter(subFooter)
  }

  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setSavingsTheme(savingsTheme)
    setisBorderNone(isBorderNone)
    setIsSubFooter(isSubFooter)
  }
  const showAlertModalManage = (showModelManage, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1TextColor, btn1BgColor) => {
    setshowErrorImg(showErrorImg)
    setisBorderNone(false)
    setShowModelManage(showModelManage)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setFooterMsg(footerMsg)
    setBtn1TextColor(btn1TextColor)
    setBtn1BgColor(btn1BgColor)

}
  

  
  const onAcptBtnClickPlusModal = () =>{
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    }
  }
  const onCancelBtnClickPlusModal = () =>{
    setShowPlusModal(false)
    showAlertModal(true, '', <p><span className='text-[var(--enroll-maybelater-hilight)]'>{t('no_problem_exclimation')}</span><span>{" "}</span>{t('You_may_add_a_Kudzu_SavingsAc_count_at_any_time')}</p>, t('via_account_services_title'), true, false, t('okay_got_it'), '', true, appThemeData.cell, true, true);
  }
  const closeModelPlus = () =>{
    setShowPlusModal(false)
  }

  const openHeadsUpModal = () => {
    showAlertModal(true, t("heads_up"), t('u_r_abt_to_leave'), t("u_r_being_directed"), true, true, 'Continue', t("cancel"), true, '', true, false, false)

}
const openHeadsUpModalManage = () =>{
  showAlertModalManage(true, t("heads_up"), t('u_r_abt_to_leave'), t("u_r_being_directed"), true, true, 'Continue', t("cancel"), true, '', '', false, true)
}

  const footerContent = () => {
    return (
      < FooterContent
        highlightText={t("climb_heading")}
        subHeaderText={t("climb_subheading")} image={ClimbImg}
        buttonEnabled={true} buttonText={t("climb_btn")} isSpace={true} footerBtnAction={() => {
          //  navigate('/Climb');
          navigate("/Climb/ClimbMenu", { state: { isClimbShowPopups: true } });
          const currentPath = { currentPathFromStore: currentpath.pathname };
          dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
          logFirebaseEvents("Manage_Account", "Explore_Climb_Clicked", "Explore_Climb_Clicked", "", "");
        }} borderDirection={cards?.[0]?.AllowPayPerks ? (cards?.length % 2 == 0) ? 'odd' : 'even' : (cards?.length % 2 == 0) ? 'even' : 'odd'} />
    )

  }
  const enrollSavingsFooterContent = () => {
    return (
      kudzuPlusTrue ?
        <DynamicCardSavings
          footer={true}
          header={false}
          CardRadius={false}
          cardWidth={width.homeCard}
          HeaderRadius={false}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          backgroundColor={'--cardHeading-bg'}
          HeaderContent={
            <>
              <CardHeading heading={t('savings')} image={appThemeData.isBlueIconForSavings}
                endBtnText={t('enroll')} endBtn={true} headerButtonClick={canCreateSavingsAccount} />
            </>
          }
        >

          <div className="my-20">
            <div className="flex justify-between">
              <div>
                <p className="text-white md:w-[310px]">{t('set_aside_money_for_things_that_matter')}</p>
              </div>
              <div>
                <img src={BenificiaryPlus} alt="Benificiary" />
              </div>
            </div>
          </div>

        </DynamicCardSavings> :
        < FooterContent
          cardHeight={'200px'}
          backgroundColor={'#D3D3D3'}
          btnBgColor={'#30BC89'}
          btnTextColor={'#FFFFFF'}
          isSubheadingwidth={true}
          highlightTextColor={'#0C4437'}
          subHeaderTextColor={'#0C4437'}
          highlightText={t("grow_urMoney_withSavings")}
          subHeaderText={LineBreaks(t("set_aside_funds_savings"))}
          image={beneficiarysaving}
          buttonEnabled={true}
          buttonText={t("enroll")} isSpace={true}
          type={'climbFooterHome'}
          footerBtnAction={() => {
            const savingsNewPayload = { savingsNewClicked: true };
            dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
            showAlertModal(true, '', t('set_aside_money_for_the_things_that_matter'), t('add_savings_account_subTitle'), true, true, t('enroll'), t('may_be_later'), true, beneficiarysaving, true, true);
          }}
          borderDirection={cards?.[0]?.AllowPayPerks ? (cards?.length % 2 == 0) ? 'odd' : 'even' : (cards?.length % 2 == 0) ? 'even' : 'odd'}
        />
    )
  }
  const verificationSuccess = () => {
    if (isTinkFlowEnabled) openHeadsUpModalManage();
    else {
        if (location.pathname.includes('/AccountServices/ManageExternalAccounts')) navigate('/AccountServices/ManageExternalAccounts/AddExternalAccount')
        else navigate('/Settings/ManageExternalAccounts/AddExternalAccount')

    }
}
  return (

    <HomeLayout>
      <HomeHeader heading={LineBreaks(t("here_kudzu_accounts"))} isHeaderCaption={true} />
      <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
       animate__animated animate__fadeInRight '>
        <DynamicCard
          header={true}
          footer={false}
          CardRadius={true}
          HeaderRadius={true}
          cardWidth={width.homeCard}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          backgroundColor={'--cardHeading-bg'}
          HeaderContent={
            <>
              <CardHeading heading={t("manage_accounts")} />
            </>
          }

        >

          {/* <div className="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] 
 lg:text-[26px] md:text-[22px] 
 sm:text-[20px] text-[20px]
 leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
            {t('manage_accounts')}
          </div> */}

          <div className={`${kudzuPlusTrue ? '' : 'border-t-[2.5px] border-[#A3CEBB]'}
                     flex justify-center flex-col sm:mx-0 mx-4`}>
            {subObjectsArray.map((item, index) => (
              <div className='md:h-[180px] sm:h-[135px] h-[155px] border-b-[1px] 
                                     flex justify-center border-[var(--border-bt-color-manageAcc)]  items-center sm:mx-0 mx-4'>
                <div className='sm:w-[83%] w-full'>
                  <div key={index}>
                    <p className='font-hanken-grotesk text-[var(--accName-Manage-color)] 
                                        uppercase lg:text-[13px] md:text-[12px] 
                                        sm:text-[11px] text-[13px]  font-[600] tracking-[2px] md:pb-8 pb-5'>
                      {t("account_name").toLocaleUpperCase()}</p>
                    <div className='flex flex-row justify-between sm:w-auto w-full'>

                      <div className='flex flex-row sm:items-start sm:w-auto w-full items-center sm:pb-0 pb-4
                                             sm:justify-self-auto justify-between'>

                        <div>
                          <p className="font-[700] md:text-[16px] sm:text-[10px] text-[14px] mr-2 text-[var(--modal-text-heading-clr)] 
                                             cursor-pointer pointer-events-none">
                            {item.AccountTypeName.replace(" Account", "")}
                            {item.CardKey != '' && <span className={`md:text-[12px] sm:text-[11px] before-dots font-[700] text-[var(--modal-text-heading-clr)]`}>{item.CardKey}</span>}
                          </p>

                          {(item.ApplicationDate != undefined && item.ApplicationDate != null && item.ApplicationDate != '9999-12-31' && item.CardKey != 'empty') && <p className='my-3 font-hanken-grotesk font-medium text-[12px] leading-4 text-[var(--modal-text-heading-clr)]'>{t("account_opend")} <span>{moment(item.ApplicationDate).format('MM/DD/YYYY')}</span> </p>}
                          {item.OpenDate == 'empty' && <p className='my-3 font-hanken-grotesk font-medium text-[12px] leading-4 text-[var(--modal-text-heading-clr)]'>
                            {t("open_savings_today")} </p>}

                        </div>
                        {item.CardKey != '' && <img src={check_img} className="lg:w-[20px] lg:h-[20px] md:w-[16px] md:h-[16px] sm:w-[13px] sm:h-[13px] w-[15px] h-[15px] sm:ml-5" />}

                      </div>
                      {item.CardKey == '' &&
                        <div
                          className={`border-2
                          border-[var(--enroll-btnBorder)] flex items-center text-[var(--enroll-btnColor)]
                   justify-center text-center w-auto px-[15px] py-3 md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                   lg:text-[15px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk cursor-pointer`}
                          onClick={canCreateSavingsAccount}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                              canCreateSavingsAccount()
                            }
                          }}
                          tabIndex={0} // Set tabIndex here for the button
                        >
                          Enroll
                        </div>
                      }

                    </div>

                    {/* {(item.ApplicationDate != undefined && item.ApplicationDate != null  && item.ApplicationDate != '9999-12-31' && item.CardKey != 'empty') && <p className='my-3 font-hanken-grotesk font-medium text-[12px] leading-4'>{t("account_opend")} <span>{moment(item.OpenDate).format('MM/DD/YYYY')}</span> </p>}   */}


                  </div>
                </div>
              </div>
            ))}
            {cards !== null && cards[0]?.AllowSavings && <div className='md:h-[180px] sm:h-[135px] h-[155px] border-b-[1px] 
                                     flex justify-center border-[var(--border-bt-color-manageAcc)]  items-center sm:mx-0 mx-4'>
                                      <div className='sm:w-[83%] w-full'>
                                      <button className='w-full border-[2.5px] border-[var(--manage-border)] py-4 px-24 text-[var(--modal-text-heading-clr)] text-[16px] font-hanken-grotesk font-bold'
                                      onClick={() => {
                                        logFirebaseEvents("Manage_External_Account", "Add_External_Account_Clicked", "Add_External_Account_Clicked", "", "");
                                        if(MFAValues) {
                                          if (isTinkFlowEnabled) openHeadsUpModalManage();
                                        } else {
                                          if (twoFactAuthenticationDone) {
                                            if (isTinkFlowEnabled) openHeadsUpModalManage();
                                            else {
                                                if (location.pathname.includes('/AccountServices/ManageExternalAccounts')) navigate('/AccountServices/ManageExternalAccounts/AddExternalAccount')
                                                else navigate('/Settings/ManageExternalAccounts/AddExternalAccount')

                                            }
                                        }
                                        else { setshow2faSelection(true) }
                                        }
                                        
                                    }}>{t('add_external_acc')}</button>

                                      </div>
                                      
              
            </div>}

            <div className={`${kudzuPlusTrue ? '' : 'border-t-[2.5px] border-[#D1E7DD]'} flex flex-col justify-center sm:mx-0 mx-4`}>
              <MoreServices actionsArray={moreServicesArray} isMoresetting={true} />
            </div>


          </div>

          {isTinkModal &&

<TinkLinkModal
    isOpen={isTinkModal}
    onClose={() => setIsTinkModal(false)}
    content={

        <iframe src={YOUR_AUTHENTICATION_LINK} width='100%' height="700px" title="Tink Link Account Check" />

    }
/>

}



          {loading && <Loader />}
        </DynamicCard>
        {/* {savingsCardAvailable == false ? enrollSavingsFooterContent() :footerContent()} */}
        {savingsCardAvailable == false && cards !== null && cards[0]?.AllowSavings ? enrollSavingsFooterContent() : ''}
      </div>

      <CustomAlertModel isOpen={showModel}
        modalBg={!isSubFooter &&  'bg-[var(--text-bg-subway)]'}
        btn1BorderColor={!isSubFooter && '#30BC89'}
        btn1TextColor={!isSubFooter && '#FEFAEE'}
        btn1BrExist={!isSubFooter &&  kudzuPlusTrue ? false : true}
        btn2TextColor={(kudzuPlusTrue)?('#779CE5'):("#559C7E")}
        btn1BgColor={!isSubFooter && kudzuPlusTrue ? "" : '#30BC89'}
        onClose={closeCustomAlertModal}
        image={modelImage}
        highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
          <span className={`${HeaderMsgStyles} ${savingsTheme ?  'text-[var(--text-clr-secondary6)]' : 'text-[#0C4437]'}`}> {headerMsg}</span></p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text} btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        verificationFailure={() => { }}
        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        isBorderNone={kudzuPlusTrue}
        subFooter={isSubFooter && subComponent()}
      />
<CustomAlertModel isOpen={showModelManage}
                onClose={closeCustomAlertModalManage}
                image={modelImage}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={footerMsgstyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClickManage}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
                btn2Focus={btn2Focus}
                btn1BgColor={btn1BgColor}
                btn1TextColor={btn1TextColor}
            />

      <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
        image={modelImage}
        carousel={carousel}
        summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
        isBorderNone={isBorderNone}
        highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn1BgColor={btn1BgColor}
        btn2Text={btn2Text}
        opacityLow={opacityValueLow}
        defaultCornerRadius={false}
        btn1TypeAcpt={btn1TypeAcpt}
        onAcptBtnClick={onAcptBtnClickPlusModal}
        onCancelBtnClick={onCancelBtnClickPlusModal}
        gradientButton={gradientButton}
        largeImage={largeImage}
        subFooter={subFooter}
      />
      
{isOTPVerifyModalOpen &&
<Modal
    isOpen={isOTPVerifyModalOpen}
    onClose={closeOTPVerifyModal}
    isLogo={false}
    subHeaderMsg={<p className="font-hanken-grotesk   text-[var(--modal-text-heading-clr)]  modal-title md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none">{otpGenerationType != 'Email' && t("standard_msg_and_data_rates_may_apply")}</p>}
    title={<p className={HighlightMsgStyles}> {t("great_exclamation")}</p>}
    subtitle={<p className={HeaderMsgStyles}>{otpGenerationType == 'Email' ? t("we_are_sending_text").replace("a text", "an email") : t("we_are_sending_text")}</p>}
    content={<div className="mt-10"><Custom2FA type={t('add_external_account')} selected2FAType={otpGenerationType} onClose={closeOTPVerifyModal} verificationSuccess={verificationSuccess} verificationFailure={() => { }} /></div>}
/>
}
<TwoFactTypeSelctionModal isOpen={show2faSelection} onClose={() => { setshow2faSelection(false) }} onClickNext={(object) => { setOtpGenerationType(object.proc); setshow2faSelection(false); onClickAddExternalAcc(object.proc); }} />
      {isLoading && <Loader />}
    </HomeLayout>
    


  )
}

export default ManageAccounts;
